export const FIREBASE_CONFIG = {
    // apiKey: "AIzaSyBLUh9FeIulr13H-_B5iprSXXomInlsE6Q",
    // authDomain: "remotefit-c608c.firebaseapp.com",
    // databaseURL: "https://remotefit-c608c.firebaseio.com",
    // projectId: "remotefit-c608c",
    // storageBucket: "remotefit-c608c.appspot.com",
    // messagingSenderId: "1079843244567",
    // appId: "1:1079843244567:web:38b192fa1e1e6380e82a52",
    // measurementId: "G-952P0DFSC9"
    apiKey: "AIzaSyB1_7_AlFq027skooNut3U4uydMUwwjHak",
    authDomain: "boldapp-project.firebaseapp.com",
    databaseURL: "https://boldapp-project.firebaseio.com",
    projectId: "boldapp-project",
    storageBucket: "boldapp-project.appspot.com",
    messagingSenderId: "312042988695",
    appId: "1:312042988695:web:51f10c79168645027bb5d2",
    measurementId: "G-0G96K8QH7K"
    // apiKey: "AIzaSyANv7YYGXfFX72Dd8MUmA0oi-91vKxGsKk",
    // authDomain: "bold-academy.firebaseapp.com",
    // databaseURL:  "https://bold-academy-default-rtdb.europe-west1.firebasedatabase.app",
    // projectId: "bold-academy",
    // storageBucket: "bold-academy.appspot.com",
    // messagingSenderId: "567239096561",
    // appId: "1:567239096561:web:71af7af27e7053492f1150",
    // measurementId: "G-ZGDECRS5B8"
}



// WEBPACK FOOTER //
// ./src/app/firebase.credentials.ts